export default (params) => {
    const tourCriteria = {};
    const element = params.toCity;
    if (element) {
        tourCriteria.resorts = element.split('.');
    }

    return tourCriteria;
};